import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import DepositTypeCard
  from 'Views/Page/Content/Templates/SelectTransferTypeTemplate/Content/DepositTypeCardGroup/DepositTypeCard';
import useMobileLayout from 'Hooks/useMobileLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useStyles = buildUseStyles('DepositTypeCardGroup', (theme) => ({
  root: {
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.facet.backgroundGray,
  },
  layout: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
  },
  mobileLayout: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
}));

const DepositTypeCardGroup = ({
  className,
  depositTypesCollection,
}) => {
  const isMobile = useMobileLayout();
  const theme = useTheme();
  const classes = useStyles(theme);
  const { loadPageContentLink } = usePageContentContext();
  const depositTypes = depositTypesCollection.resources().list();

  return (
    <Box
      className={classNames(classes.root, className, classes.layout, { [classes.mobileLayout]: isMobile })}
    >
      {depositTypes.map(type => (
        <DepositTypeCard
          key={type.id()}
          title={type.attr('title')}
          imgSrc={type.attr('image')}
          onClick={() => loadPageContentLink(type.relationship(fr.relationships.transferWizard.name).link('related'))}
          test={`${type.id()}-card`}
        />
      ))}
    </Box>
  );
};

DepositTypeCardGroup.defaultProps = {
  className: '',
};

DepositTypeCardGroup.propTypes = {
  className: PropTypes.string,
  depositTypesCollection: PropTypes.arrayOf(fr.Collection).isRequired,
};

export default DepositTypeCardGroup;
